var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-tree"},[(_vm.tree)?_c('div',{staticClass:"q-ml-sm"},_vm._l((_vm.tree.downlines),function(downlines,index){return _c('tree-item',{key:index,attrs:{"model":downlines}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }